import { createTheme } from '@material-ui/core';

const createMaterialUiTheme = (darkMode) => createTheme({
  breakpoints: {
    keys: [
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
    ],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1344,
    },
  },
  palette: {
    type: darkMode ? 'dark' : 'light',
    primary: {
      light: '#66E0F2',
      main: '#00CCDD',
      dark: '#0099AA',
      contrastText: '#000',
    },
    secondary: {
      light: '#66E0F2',
      main: '#00CCDD',
      dark: '#0099AA',
      contrastText: '#fff',
    },
    text: darkMode
      ? {
        primary: '#fff',
        secondary: '#8c8b91',
        alpha: 'rgba(231, 231, 231, .44)',
      }
      : {
        primary: '#000',
        secondary: '#000',
        alpha: 'rgba(24, 24, 24, .44)',
      },
    background: darkMode
      ? {
        paper: '#272727',
        default: '#181818',
      }
      : {
        paper: '#f1f1f1',
        default: '#fff',
      },
    backgroundAlpha: darkMode ? 'rgba(24, 24, 24, .95)' : 'rgba(255, 255, 255, .95)',
  },
  spacing: 7,
  typography: {
    overline: {
      letterSpacing: 2,
    },
    caption: {
      color: darkMode ? 'rgba(140, 139, 145, .5)' : 'rgba(0, 0, 0, .5)',
    },
  },
  toastDialog: {
    alignItems: 'flex-start',
    backdropFilter: 'blur(18px)',
    background: darkMode ? 'rgba(31, 31, 31, 0.92)' : 'rgba(255, 255, 255, 0.94)',
    border: `1px solid ${darkMode ? 'rgba(255, 255, 255, 0.10)' : 'rgba(17, 24, 39, 0.10)'}`,
    borderRadius: 18,
    boxShadow: darkMode
      ? '0 18px 42px rgba(0, 0, 0, 0.36)'
      : '0 18px 42px rgba(15, 23, 42, 0.18)',
    color: darkMode ? '#fff' : '#000',
    display: 'flex',
    maxWidth: 'calc(100vw - 32px)',
    minHeight: 84,
    overflow: 'visible',
    padding: '12.25px 15.75px',
    width: 'fit-content',
    WebkitBackdropFilter: 'blur(18px)',
    '& .Toastify__toast-body': {
      margin: 0,
      padding: 0,
      width: '100%',
    },
    '& .Toastify__toast-icon': {
      display: 'none',
    },
    '& .Toastify__close-button': {
      alignItems: 'center',
      alignSelf: 'flex-start',
      backgroundColor: 'transparent',
      color: darkMode ? '#a8a8ad' : '#5f6875',
      display: 'flex',
      flexShrink: 0,
      height: 32,
      justifyContent: 'center',
      marginLeft: 7,
      opacity: 1,
      padding: 4,
      width: 32,
      '&:hover': {
        opacity: 0.9,
      },
    },
    '& .Toastify__close-button svg': {
      height: 18,
      width: 18,
    },
  },
  overrides: {
    MuiOutlinedInput: {
      input: {
        '&:-webkit-autofill': darkMode
          ? {
            WebkitBoxShadow: '0 0 0 100px #272727 inset',
            WebkitTextFillColor: '#fff',
          }
          : {
            WebkitBoxShadow: '0 0 0 100px #f1f1f1 inset',
            WebkitTextFillColor: '#000',
          },
      },
    },
    MuiCardActionArea: {
      root: {
        '&:hover $focusHighlight': {
          opacity: '0.1',
        },
        '&:active $focusHighlight': {
          opacity: '0.1',
        },
      },
      focusHighlight: {
        backgroundColor: '#666',
      },
    },
    MuiCard: {
      root: {
        borderRadius: 0,
      },
    },
    MuiIconButton: {
      root: {
        color: darkMode ? '#fff' : '#000',
      },
    },
    MuiButton: {
      containedPrimary: {
        color: '#fff',
      },
      root: {
        textTransform: 'capitalize',
      },
    },
    MuiTab: {
      wrapper: {
        minWidth: 90,
      },
      root: {
        textTransform: 'none',
        letterSpacing: 0,
        color: '#666',
        fontWeight: 400,
        minWidth: '90px !important',

        '&$selected': {
          color: darkMode ? '#fff' : '#000',
          fontWeight: 500,
        },
      },
      textColorInherit: {
        color: darkMode ? '#8c8b91' : '#666',
        opacity: 1,
      },
    },
    MuiTabs: {
      root: {
        color: '#666',
      },
      indicator: {
        color: '#000',
      },
    },
  },
});

export default createMaterialUiTheme;
